import { api_GET } from "./_api.js";

const dashboard_api = {
    get: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Dashboard`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default dashboard_api;
